'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiFlash = function TiFlash(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.2 20.1l-7.1-4.1 3.6-8.6c0.1-0.2 0.1-0.5 0.1-0.7 0-1-0.7-1.7-1.6-1.7-0.4 0-0.8 0.1-1.1 0.4 0 0 0 0-0.1 0.1l-12.5 11.8c-0.4 0.3-0.6 0.9-0.5 1.4s0.4 1 0.8 1.2l7.1 4.1-3.6 8.7c-0.3 0.7-0.1 1.6 0.6 2 0.3 0.2 0.6 0.3 0.9 0.3 0.4 0 0.9-0.2 1.2-0.5l12.5-11.8c0.4-0.4 0.5-0.9 0.5-1.4-0.1-0.5-0.4-1-0.8-1.2z' })
        )
    );
};

exports.default = TiFlash;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/flash.js
// module id = 3601
// module chunks = 0